import React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import InsertBasketModal from "./InsertBasketModal";

interface InsertBasketModalProperties {
    readonly productId: number;
    readonly onClose: () => void;
}

export default function InsertBasketApp({ productId, onClose }: InsertBasketModalProperties): React.JSX.Element {
    const queryClient = new QueryClient();

    return (
        <QueryClientProvider client={queryClient}>
            <InsertBasketModal productId={productId} onAfterClose={onClose} />
        </QueryClientProvider>
    );
}
